import React from 'react';
import Header from '../components/Header';
import TeamSection from '../components/TeamSection';
import Footer from '../components/Footer';

const Team = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <TeamSection />
      </main>
      <Footer />
    </div>
  );
};

export default Team;
